import { endlessRequest } from "./core";
import { EndlessRequest, EndlessResponse } from "./types";

export type GetRequestOptions = Omit<EndlessRequest, "body" | "method">;

/**
 * Main function to do a Get request
 *
 * @param options GetRequestOptions
 * @returns
 */
export async function get<Req, Res>(options: GetRequestOptions): Promise<EndlessResponse<Req, Res>> {
  const response: EndlessResponse<Req, Res> = await endlessRequest<Req, Res>({ ...options, method: "GET" });
  return response;
}
